import { render, staticRenderFns } from "./MenuBlock.vue?vue&type=template&id=34a40655&"
import script from "./MenuBlock.vue?vue&type=script&lang=js&"
export * from "./MenuBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a40655')) {
      api.createRecord('34a40655', component.options)
    } else {
      api.reload('34a40655', component.options)
    }
    module.hot.accept("./MenuBlock.vue?vue&type=template&id=34a40655&", function () {
      api.rerender('34a40655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/header/MenuBlock.vue"
export default component.exports